require('/js/yext/externalaccounts/listingslaunch/styles/listingslaunchexternalaccounts.module.scss.module.css');

export const linkExternalAccount = "_link-external-account_1mi5q_1";
export const linkExternalAccountContent = "_link-external-account-content_1mi5q_1";
export const svgContainer = "_svgContainer_1mi5q_1";
export const cta = "_cta_1mi5q_1";
export const ctaButtons = "_ctaButtons_1mi5q_1";
export const ctaCreateAccountButton = "_ctaCreateAccountButton_1mi5q_1";
export const externalAccountsTable = "_externalAccountsTable_1mi5q_1";
export const tableContainer = "_table-container_1mi5q_1";
export const ctaMobile = "_cta-mobile_1mi5q_1";
export const ctaMobileButtons = "_cta-mobile-buttons_1mi5q_1";
export const ctaMobileLinkButton = "_cta-mobile-link-button_1mi5q_1";
export const mobileLinkExternalAccountContent = "_mobile-link-external-account-content_1mi5q_1";
export const mobileAccountTableLabel = "_mobile-account-table-label_1mi5q_1";
export const mobileAccountCardContainer = "_mobile-account-card-container_1mi5q_1";
export const mobileAccountCard = "_mobile-account-card_1mi5q_1";
export const mobileAccountCardRow = "_mobile-account-card-row_1mi5q_1";
export const mobileAccountCardKey = "_mobile-account-card-key_1mi5q_1";
export const mobileAccountCardValue = "_mobile-account-card-value_1mi5q_1";
export const mobileRelinkButton = "_mobile-relink-button_1mi5q_1";
